export default "__VITE_ASSET__PSqhgjMT__"